var map = {
	"./_it-IT.json": 3346,
	"./_zh-CN.json": 9169,
	"./da-DK.json": 828,
	"./de-DE.json": 5857,
	"./en-GB.json": 9398,
	"./en-US.json": 3464,
	"./fr-FR.json": 2631,
	"./it-IT.json": 2277,
	"./ja-JP.json": 168,
	"./ko-KR.json": 2148,
	"./ro-RO.json": 8584,
	"./zh-CN.json": 2081
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5000;